import styled from '@emotion/styled'
import React from 'react'

import { color, getColor, theme } from '../../Theme'

interface ButtonProps {
  background?: string
  isCommuter?: boolean
  noClick?: boolean
  hidden?: boolean
}

const Button = styled.button<ButtonProps>`
  ${theme.text('normal', 'content', 'bold')};
  ${theme.spacing.sides('smallest')};
  ${theme.spacing.ends('tiny')};
  background: ${(p) => p.background || color('primaryBlue')};
  border: none;
  border-radius: ${theme.borderRadius.button};
  color: ${color('white')};
  cursor: ${(p) => (p.noClick ? 'default' : 'pointer')};
  text-transform: none;
  letter-spacing: 0;
  height: 34px;
  outline: none;
  display: ${(p) => (p.hidden ? 'none' : 'flex')};
  justify-content: center;
  flex: 0 1 ${(p) => (p.isCommuter ? '24%' : '19%')};
  &[disabled] {
    color: ${(p) => getColor(p.theme, ['white'], ['grayPink'])};
    background: ${(p) => getColor(p.theme, ['shallowBlue'], ['nightGray'])};
  }
  margin: 0 1px;
  &:first-of-type {
    margin-left: 0;
  }
  &:last-of-type {
    margin-right: 0;
  }
`

type Props = {
  children: JSX.Element
  background?: string
  disabled?: boolean
  hidden?: boolean
  isCommuter?: boolean
  full?: boolean
  noClick?: boolean
  onClick: () => void
}

const TaskButton = ({
  children,
  background,
  disabled,
  hidden,
  isCommuter,
  noClick,
  onClick,
}: Props) => {
  return (
    <Button
      background={background}
      disabled={disabled}
      hidden={hidden}
      isCommuter={isCommuter}
      noClick={noClick}
      onClick={onClick}
    >
      {children}
    </Button>
  )
}

export default TaskButton
